class UIHelp {
    constructor(helpContent, replacedWords = {}) {
        this.elements = helpContent;
        this.replacedWords = replacedWords || {};
        this.introJs = require('intro');
        this.defined = false;
        this.configuredForPage = null;
    }

    setupFor(page) {
        let stepsCount = 0;
        let self = this;
        this.elements.filter(item => self.pageMatch(page, item.page)).sort(function (a, b) {
            if (a.step > b.step) {
                return 1;
            } else if (a.step < b.step) {
                return -1;
            }

            return 0;
        }).forEach((element) => {
            let dom = $(`#${element.selector}`);
            if (dom.length > 0 && dom.is(":visible") && dom.width() > 0 ) {
                this.defined = true;
                stepsCount += 1;
                dom.attr('data-step', stepsCount);
                dom.attr('data-intro', self.replaceWordInSentence(element.intro));
                dom.attr('data-disable-interaction', true);
                dom.attr('data-scrollTo', window.innerWidth < 1000 ? 'tooltip' : 'element');
                
            }
        });
    }

    replaceWordInSentence(text) {
        Object.keys(this.replacedWords).map(findWord => {
            const replaceWord = this.replacedWords[findWord];
            text = text.replace(findWord, replaceWord);
        })

        return text;
    }

    pageMatch(currentPage, helpPage) {
        if (helpPage.includes('*')) {
            return currentPage.match(new RegExp(helpPage));
        }

        return currentPage === helpPage;
    }

    show() {
        let body = document.body;
        let sidebar = document.querySelector('#sidebar-wrapper');
        
        const windowPage = window.location.pathname;
        if (!this.configuredForPage || this.configuredForPage !== windowPage) {
            this.setupFor(windowPage);
        }

        if (this.defined) {
          this.introJs().setOptions({
            skipLabel: '',
            exitOnOverlayClick: false,
          }).start().onbeforeexit(function() {
                body.style.cssText = 'overflow: auto;';
                sidebar.style.cssText = 'position: fixed;';
            });

        }
        sidebar.style.cssText = 'position: absolute;';
    }

    firstShow(storage){
      if (storage && typeof(storage) == "string"){
        storage = storage.replace(/\d+/gi, '*');
      }
      if(localStorage.getItem(storage)){
        this.show();
        localStorage.removeItem(storage);
      }
    }
}
export default UIHelp;